import { Injectable } from '@angular/core';
import { Subject } from "rxjs/index";
import { NotificationMsg } from "../model/notificationMsg.model";
import {Action} from "../model/action.model";
import {isDate} from "@angular/common/src/i18n/format_date";


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

    constructor() { }
    private sub: Subject<any> = new Subject();

     notifications$: Subject<NotificationMsg[]> = new Subject();
     _notifications: NotificationMsg[] = [];

    public emitter = this.sub.asObservable();

    display(type, message) {
        this.sub.next({type, message});
    }

    /**
     *  Alert Notifications Implementations
     *
     *   - showAlert( title, message?, actionText?, actionLink?,  type?, slotID? )
     *   - updateAlert(id, data)
     *   - isAlert(id)
     *   - clearAlerts(id)
     *   - clearAllAlerts()
     *
     *   TODO:
     *   - define Types
     *   - make available the icons by classes
     *   - style by type.
     *
     * ****/

    showAlert( title, message?, actionText?, actionLink?,  type?, slotID? ){
        let cstStyle = "notification-alert alert";
        let l = this._notifications.length;
        let id = ((slotID) || (slotID != '') )? slotID : "a-"+l.toString()+"-"+(new Date()).getTime();
        let actions = ((actionText)||(actionText != ''))? [{
                text: actionText,
                link: actionLink
            }]: [];
        let notify: NotificationMsg = {
            id: id,
            type: "alert",
            title: title,
            message: message,
            icon: "cinch-alert",
            actions: actions,
            meta: {
                alertType: type,
                slotID: slotID
            }
        };
       // console.log(notify);

        let index = l;
        // making sure no new element with the same id get created on the array
        if ((slotID) && (this.isAlert(slotID))){
            // update a element on the array
            this.updateAlert(id, notify);
        } else {
            // add a new element on the array
            index = this._notifications.push(notify);
        }

       // console.log(this._notifications);
        this.notifications$.next(this._notifications);
        //return index of this element
        return index;
    }
    updateAlert(id, data){
        let updateOnID = (val, i, arr) => {
            if (val.id === id) return data;
            else return val;
        };
        this._notifications = this._notifications.map(updateOnID);
        return this._notifications;
    }
    isAlert(id){
        let checkAlertID = (val, i, arr)=> {
            return val.id === id;
        };
        return this._notifications.some(checkAlertID);
    }
    clearAlerts(id){
        //delete fruits[id];
        //fruits.splice(0, 1);        // Removes the first element of fruits
        let checkID = (val, i, arr) => {
            return val.id != id;
        };
        this._notifications= this._notifications.filter(checkID);
       // console.log("notification Service clearAlerts - notify:", this._notifications, id);
        this.notifications$.next(this._notifications);
    }
    clearAllAlerts(){
        this._notifications = [];
        this.notifications$.next(this._notifications);
    }

    /**
     *  POP Notifications Implementations <future>
     *
     *   TODO:
     *   - show pop
     *   - clear pop
     *   - define Types
     *   - make available the icons by classes
     *   - style by type.
     *
     * ****/
}
